module.exports = __webpack_public_path__ + "img/73_17.b2dc066a.png";